import React from "react";
import {
    Navigate
} from "react-router-dom";
import {clearSession, getAccessToken} from "./authority";
import {jwtDecode} from "jwt-decode";
import pako from "pako";

/**
 * Kiểm tra quyền của user hiện tại
 * Quyền thực tế luôn lấy từ authorities trong JWT do server phát hành.
 * Không dùng danh sách hard-code theo roleType vì danh sách đó có thể lệch
 * với role_permission và làm ẩn các module đã được server cấp quyền.
 * @param {string} permission - Quyền cần kiểm tra (có thể chứa "|" để check nhiều quyền)
 * @returns {boolean} True nếu user có quyền
 */
export function checkPermission(permission) {
    const token = getAccessToken();
    if (token === undefined){
        return false;
    }

    try {
        const decodedToken = jwtDecode(token);
        const list_permission = decodeBase64(decodedToken["authorities"]);
        if (!list_permission) return false;
        const grantedPermissions = new Set(
            list_permission
                .replace(/^\[|\]$/g, "")
                .split(",")
                .map(p => p.trim())
                .filter(Boolean)
        );

        const permissionArr = permission.split("|").filter(p => p.trim() !== "");
        // So khop TUYET DOI (khong dung indexOf): "S1" tung khop nham chuoi con cua "SMS1",
        // khien nut/menu hien sai so voi @PreAuthorize cua server (server dung equals).
        return permissionArr.some(p => grantedPermissions.has(p.trim()));
    } catch (error) {
        console.error("Error checking permission:", error);
        return false;
    }
}
export function decodeBase64(base64String) {
    try {
        // Giải mã Base64
        const binaryString = atob(base64String);
        const binaryData = Uint8Array.from(binaryString, char => char.charCodeAt(0));

        // Giải nén GZIP
        const decompressedData = pako.inflate(binaryData, { to: 'string' });
        return decompressedData;
    } catch (error) {
        return null;
    }
}
/**
 * Phiên còn hiệu lực? Kiểm tra luôn claim exp trong JWT (TTL server 7 ngày,
 * xem ba-shared/api-contracts/auth/session-expiry.md) thay vì chỉ xem token có
 * tồn tại hay không — nếu không, user mở tab với token chết vẫn vào được trang
 * rồi mới bị đá ra khi API đầu tiên trả 401.
 * Token hết hạn thì dọn luôn phiên; phần điều hướng để <Navigate/> lo.
 */
function hasValidSession() {
    const token = getAccessToken();
    if (!token) return false;
    try {
        const { exp } = jwtDecode(token);
        if (exp && exp * 1000 <= Date.now()) {
            clearSession();
            return false;
        }
    } catch (error) {
        // Token hỏng/không decode được — coi như không có phiên.
        clearSession();
        return false;
    }
    return true;
}

export function RequireAuth({ children, redirectTo }) {
    return hasValidSession() ? children : <Navigate to={redirectTo} replace />;
}


export function RedirectAuth({ children, redirectTo }) {
    return hasValidSession() ? <Navigate to={redirectTo} replace />: children;
}
export function changeAlias(alias) {
    if(alias) {
        let str = alias;
        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
        str = str.replace(/ + /g, " ");
        str = str.trim();
        return str;
    }
    return alias;
}
